export default __webpack_public_path__ + "static/media/private_privacy_icon.db904262.svg";